/**
 * Web core
 */

window.Adzuki.Web = (function Web($, Adzuki)
{
	"use strict";
	var web = {};

	// this is a workaround for in-page anchor links while also using <base>.
	// that's not normally allowed, but we use the <base> tag for stuff.
	// so re-write all urls for anchors that start with #,
	// only within page contents, to make it function the way you'd expect.
	// this is mostly helpful for agents who have their own anchors on their pages.
	$(".content a[href^='\#']").not("a[data-toggle='tab']").each(function fixAnchors() {
		this.href = location.href.split("#")[0] + '#' + this.href.substr(this.href.indexOf('#') + 1);
	});

	return web;
}(jQuery, window.Adzuki || {}));
